export default {
    getFoldingTypes: state => {
        return state.foldingTypes
    },
    getImpositionTaskFoldingTypes: state => {
        return state.impositionTaskFoldingTypes
    }
}